import {
     SET_ADMIN_TEST_DETAILS,
     SET_ADMIN_TEST_QUESTIONS,
     ADD_ADMIN_TEST_QUESTION,
     UPDATE_ADMIN_TEST_QUESTION,
     DELETE_ADMIN_TEST_QUESTION,
} from './actions';

const INITIAL_STATE = null;

const testDetailsReducer = (state = INITIAL_STATE, action) => {
     const testDetails = state ? { ...state } : state;

     switch (action.type) {
          case SET_ADMIN_TEST_DETAILS: {
               return action.payload;
          }
          case SET_ADMIN_TEST_QUESTIONS: {
               testDetails.questions = action.payload;
               return testDetails;
          }
          case ADD_ADMIN_TEST_QUESTION: {
               testDetails.questions.push(action.payload);
               return testDetails;
          }
          case UPDATE_ADMIN_TEST_QUESTION: {
               const newQuestions = testDetails.questions.map((question) => {
                    if (question.id === action.payload.id) {
                         return { ...question, ...action.payload };
                    }
                    return question;
               });
               const newSurveyDetails = {
                    ...testDetails,
                    questions: newQuestions,
               };
               return newSurveyDetails;
          }
          case DELETE_ADMIN_TEST_QUESTION: {
               const newQuestions = testDetails.questions.filter((question) => question.id !== action.payload);
               const newSurveyDetails = {
                    ...testDetails,
                    questions: newQuestions,
               };
               return newSurveyDetails;
          }
          default:
               return state;
     }
};

export default testDetailsReducer;
